<template>
  <transition name="modal">
    <div v-if="isVisible" class="modal-overlay" style="opacity: 1.09; display: block;">
      <div class="modal-wrapper showSweetAlert visible" data-custom-class="" data-has-cancel-button="false" data-has-confirm-button="true" data-allow-outside-click="false" data-has-done-function="true" data-animation="pop" data-timer="null" style="display: block; margin-top: -191px;">

        <em class="sa-icon sa-success icon-success"></em>
        <h2 class="modal-title">Bank Account Updated</h2>
        <p v-if="!isAdminView" class="modal-paragraph">
          Thanks for updating your bank account information. Your upcoming transactions have been automatically 
          updated to use your new default bank account. You can review these changes in the
          <strong>
            <a
              href="/#/upcoming-transactions"
              @click.prevent="goToUpcomingTransactions"
              class="upcoming-transactions-link"
            >Upcoming Transactions</a>
          </strong>
          section if you'd like to verify the updates.
        </p>
        <p v-else class="modal-paragraph">
          The user's bank account information has been successfully updated. Their upcoming transactions have been automatically 
          updated to use the new default bank account. You can review these changes in the
          <strong>
            <a
              href="#"
              @click.prevent="goToUpcomingTransactions"
              class="upcoming-transactions-link"
            >Upcoming Transactions</a>
          </strong>
          section if you'd like to verify the updates.
        </p>

        <div class="modal-buttons">
          <div class="row">
            <div class="col-md-12 text-center">
              <button type="button" class="btn btn-info btn-lg btn-accept" @click="handleOk">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BankAccountChangedWarning',
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    isAdminView: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleOk() {
      this.$emit('close');
    },
    goToUpcomingTransactions() {
      if (this.isAdminView) {
        // For admin view, emit event to scroll to segment on current page
        this.$emit('goToUpcomingTransactions');
      } else {
        // For non-admin users, navigate to the Upcoming Transactions page
        this.$router.push({ name: 'UpcomingTransactionsForInvestor' });
      }
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.upcoming-transactions-link {
  color: #31b0d5;
  text-decoration: none;
  cursor: pointer;
}

.upcoming-transactions-link:hover {
  text-decoration: underline;
}

.modal-wrapper p {
  font-size: 16px;
  text-align: center;
}

.modal-title {
  color: #127285;
  text-align: center;
}

.modal-paragraph {
  margin-bottom: 15px;
}

.modal-buttons {
  border-top: 1px solid #e5e5e5;
  position: relative;
  padding: 15px;
  margin-top: 40px;
}

.modal-buttons .btn {
  width: 75px;
}

.modal-overlay {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// BankAccountChangedWarning.vue?8b5a7a5c